import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axiosInstance from '../../utils/axiosConfig';

interface Props {
  projeID: number;
  onClose: () => void;
}

// Proje bazlı sözleşme onay süreci: temsilcinin sözleşmesi, onaylı sözleşmedeki değişiklikler
// ve iptaller projenin yöneticisinin onayına gider.
const ProjeSozlesmeOnayModal: React.FC<Props> = ({ projeID, onClose }) => {
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [sozlesmeOnayi, setSozlesmeOnayi] = useState(false);
  const [iptalOnayi, setIptalOnayi] = useState(false);
  const [yoneticiler, setYoneticiler] = useState<{ kullaniciID: number; adSoyad: string }[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axiosInstance.get(`/api/ProjeSozlesmeOnay/${projeID}`);
        setSozlesmeOnayi(res.data.sozlesmeOnayiAktif);
        setIptalOnayi(res.data.iptalOnayiAktif);
        setYoneticiler(res.data.yoneticiler || []);
      } catch {
        toast.error('Onay süreci ayarları yüklenemedi.');
        onClose();
      } finally {
        setYukleniyor(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projeID]);

  const handleKaydet = async () => {
    setKaydediliyor(true);
    try {
      await axiosInstance.post(`/api/ProjeSozlesmeOnay/${projeID}`, {
        sozlesmeOnayiAktif: sozlesmeOnayi,
        iptalOnayiAktif: iptalOnayi,
      });
      toast.success('Onay süreci ayarları kaydedildi.');
      onClose();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Kaydedilirken hata oluştu.');
    } finally {
      setKaydediliyor(false);
    }
  };

  const kart: React.CSSProperties = { border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, background: '#fff', display: 'flex', alignItems: 'flex-start', gap: 12, cursor: 'pointer' };

  const anahtar = (checked: boolean, onChange: (v: boolean) => void, baslik: string, aciklama: string) => (
    <label style={kart}>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} style={{ width: 18, height: 18, accentColor: '#cd6906', marginTop: 2 }} />
      <div>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#1a2440' }}>{baslik}</div>
        <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{aciklama}</div>
      </div>
    </label>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(15,23,42,0.5)' }} />
      <div onClick={e => e.stopPropagation()}
        style={{ position: 'relative', width: '96%', maxWidth: 620, maxHeight: '92vh', background: '#f8fafc', borderRadius: 16, display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ padding: '16px 22px', background: '#fff', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 16.5, fontWeight: 700, color: '#1a2440' }}>
              <i className="fas fa-user-check" style={{ color: '#cd6906', marginRight: 8 }}></i>Sözleşme Onay Süreci
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Temsilcinin yaptığı işlemler projenin yöneticisinin onayına gider</div>
          </div>
          <button type="button" onClick={onClose} style={{ width: 32, height: 32, border: 'none', borderRadius: '50%', background: '#f1f5f9', color: '#475569', cursor: 'pointer', fontSize: 17 }}>×</button>
        </div>

        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {yukleniyor ? (
            <div style={{ textAlign: 'center', color: '#94a3b8', padding: 30 }}><i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>Yükleniyor...</div>
          ) : (
            <>
              {anahtar(sozlesmeOnayi, setSozlesmeOnayi, 'Sözleşme ve Değişiklik Onayı',
                'Temsilcinin yaptığı sözleşme yönetici onaylayana kadar "Onay Bekliyor" olur ve daire kilitli kalır. Onaylı sözleşmede fiyat, bilgi ve taksit değişikliği talep olarak yöneticiye gider.')}
              {anahtar(iptalOnayi, setIptalOnayi, 'İptal Onayı',
                'Temsilcinin onaylı sözleşmeyi iptal etmesi talep olarak yöneticiye gider; onaylanınca sözleşme iptal edilir ve daire satışa açılır.')}

              <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 14, background: '#fff' }}>
                <div style={{ fontSize: 11.5, fontWeight: 700, color: '#475569', marginBottom: 6 }}>ONAYLAYANLAR</div>
                {yoneticiler.length > 0 ? (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {yoneticiler.map(y => (
                      <span key={y.kullaniciID} style={{ padding: '3px 10px', borderRadius: 20, background: '#eef2ff', color: '#3730a3', fontSize: 12.5, fontWeight: 600 }}>{y.adSoyad}</span>
                    ))}
                  </div>
                ) : (
                  <div style={{ fontSize: 12.5, color: '#b45309' }}>
                    <i className="fas fa-exclamation-triangle" style={{ marginRight: 6 }}></i>
                    Bu projede proje yöneticisi tanımlı değil; talepleri Admin kullanıcılar onaylar. Proje yöneticisini proje düzenleme ekranından atayabilirsiniz.
                  </div>
                )}
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 8 }}>
                  Proje yöneticileri ve Admin kendi işlemlerini onaysız yapar. Tahsilat işlemleri onaya tabi değildir.
                </div>
              </div>
            </>
          )}
        </div>

        <div style={{ padding: '12px 20px', background: '#fff', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button type="button" onClick={onClose} style={{ padding: '8px 18px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', fontSize: 13.5, cursor: 'pointer' }}>İptal</button>
          <button type="button" onClick={handleKaydet} disabled={yukleniyor || kaydediliyor}
            style={{ padding: '8px 20px', background: '#cd6906', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: kaydediliyor ? 'not-allowed' : 'pointer', opacity: kaydediliyor ? 0.75 : 1 }}>
            {kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjeSozlesmeOnayModal;
